export default "__VITE_ASSET__v5$U6nZm__"